import React from "react";
import { animated as a, useTrail } from "@react-spring/native";
import styles from "./Password.styles";

export const TrailFromRight = ({ children }) => {
  const components = React.Children.toArray(children);
  const springs = useTrail(components.length, {
    config: { mass: 5, tension: 2000, friction: 200 },
    to: [
      {
        marginRight: 0,
        opacity: 1,
      },
    ],
    from: {
      opacity: 0,
      marginRight: -100,
    },
  });

  return springs.map(({ ...style }, index) => {
    return (
      <a.View key={index} style={[style, styles.commonAnimationWrap]}>
        {components[index]}
      </a.View>
    );
  });
};
